import type { SVGProps } from "react";
const SvgListView = (props: SVGProps<SVGSVGElement>) => (
  <svg width="26" height="26" viewBox="0 0 26 26" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <rect
      x="0.64999998"
      y="2.1500001"
      width="24.700001"
      height="2.7"
      rx="1.35"
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <rect
      x="0.64999998"
      y="8.1499996"
      width="24.700001"
      height="2.7"
      rx="1.35"
      stroke="currentColor"
      strokeWidth="1.3"
    />
    <rect x="0.64999998" y="14.35" width="24.700001" height="2.7" rx="1.35" stroke="currentColor" strokeWidth="1.3" />
    <rect x="0.64999998" y="20.65" width="24.700001" height="2.7" rx="1.35" stroke="currentColor" strokeWidth="1.3" />
  </svg>
);
export default SvgListView;
